/**
 * Homepage carrier sections A/B test
 * Variant (body.ab-hp-shop-first): move Shop by Carrier before Find Your Carrier
 * Also mirrors CSS order so DOM/source order matches visual when class is applied late.
 */
(function () {
  const CLASS = 'ab-hp-shop-first';
  const FIND_HEADING = '[id*="multicolumn_qMHkJD"]';
  const FIND_GALLERY = '[id*="gallery_M4GRjR"]';
  const SHOP_TABS = '[id*="collection_tabs_jNwbCg"]';

  if (window.__homepageCarrierOrderAbBound) return;
  window.__homepageCarrierOrderAbBound = true;

  function nodes() {
    return {
      findHeading: document.querySelector(FIND_HEADING),
      findGallery: document.querySelector(FIND_GALLERY),
      shopTabs: document.querySelector(SHOP_TABS)
    };
  }

  function isVariant() {
    return document.body.classList.contains(CLASS);
  }

  function apply() {
    const { findHeading, findGallery, shopTabs } = nodes();
    if (!findHeading || !findGallery || !shopTabs) return;

    if (isVariant()) {
      if (shopTabs.nextElementSibling !== findHeading) {
        findHeading.parentNode.insertBefore(shopTabs, findHeading);
      }
      return;
    }

    // Control: Shop by Carrier after Find Your Carrier gallery
    if (findGallery.nextElementSibling !== shopTabs) {
      findGallery.after(shopTabs);
    }
  }

  apply();

  const bodyObserver = new MutationObserver(apply);
  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  document.addEventListener('shopify:section:load', apply);
})();
